import { reduce } from "lodash";
import { css } from "styled-components";
import { brightness, form, invert } from "@glossy";
import { GlossyTheme } from "@glossy/theme/types";

interface IProps {
  theme: GlossyTheme;
}

const Colors = {
  operator: "#00F",
  paren: "#00F",
  phrase: "#A50",
  boost: "#164",
  regex: "#708",
  field: "#29B8C6",
  base: "#000",
  term: "#000",
};
type Color = keyof typeof Colors;

export const getColor = (type: Color) => (props: IProps) =>
  brightness(form(props, "primary")) >= 0.5
    ? invert(Colors[type])
    : Colors[type];

export const tokenHighlights = css(
  reduce(
    Colors,
    (result, color, type) => {
      result[`.cm-${type}`] = { color: getColor(type as Color) };
      return result;
    },
    {}
  )
);
